<template>
  <div class="hw-subtabs" :style="{ '--hw-subtab-cols': mobileColumns }">
    <button
      v-for="tab in tabs"
      :key="tab.key"
      type="button"
      class="hw-subtab"
      :class="{ active: modelValue === tab.key }"
      @click="emit('update:modelValue', tab.key)"
    >{{ tab.title }}<span v-if="tab.count !== null" class="hw-subtab-count">{{ onlyCommaFormat(tab.count) }}</span></button>
  </div>
</template>

<script setup>
import { computed } from 'vue'
import figureFormatter from '@/services/utils/figureFormatter'

const props = defineProps({
  tabs: { type: Array, required: true },
  modelValue: { type: String, required: true }
})

const emit = defineEmits(['update:modelValue'])

const { onlyCommaFormat } = figureFormatter()

const mobileColumns = computed(() => props.tabs.length > 3 ? 2 : props.tabs.length)
</script>

<style scoped>
.hw-subtabs {
  display: inline-flex;
  align-self: flex-start;
  max-width: 100%;
  gap: 4px;
  padding: 4px;
  overflow-x: auto;
  scrollbar-width: none;
  background: #e2e8f0;
  border-radius: 10px;
}
.hw-subtab {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  border: 0;
  border-radius: 7px;
  background: transparent;
  padding: 6px 14px;
  font-size: 0.84rem;
  font-weight: 600;
  color: #475569;
  white-space: nowrap;
  cursor: pointer;
}
.hw-subtab:hover {
  color: #0f766e;
}
.hw-subtab:focus-visible {
  outline: 2px solid #0f766e;
  outline-offset: 2px;
}
.hw-subtab.active {
  background: #fff;
  color: #0f766e;
  box-shadow: 0 1px 3px rgba(15, 23, 42, 0.12);
}
.hw-subtab-count {
  min-width: 22px;
  padding: 0 6px;
  border-radius: 999px;
  background: #f1f5f9;
  color: #475569;
  font-size: 0.72rem;
  font-variant-numeric: tabular-nums;
  text-align: center;
}
.hw-subtab.active .hw-subtab-count {
  background: #ccfbf1;
  color: #0f766e;
}
@media (max-width: 575px) {
  .hw-subtabs {
    display: grid;
    grid-template-columns: repeat(var(--hw-subtab-cols), minmax(0, 1fr));
    align-self: stretch;
  }
  .hw-subtab {
    justify-content: center;
    padding: 6px 8px;
    white-space: normal;
    text-align: center;
  }
}
</style>
